import MultiSelectDropdown from "../MultiSelectDropdown";
import type { FormFieldOption, HandleInputChange } from "./types";

type MultiSelectInputProps = {
    name: string;
    label?: string;
    options: Array<FormFieldOption | string>;
    value?: string[];
    onChange: HandleInputChange;
};

const toOptionObject = (option: FormFieldOption | string): FormFieldOption => {
    if (typeof option === "string") {
        return { label: option, value: option };
    }
    return option;
};

const MultiSelectInput = ({ name, label, options, value = [], onChange }: MultiSelectInputProps) => {
    const filteredOptions = options
        .map(toOptionObject)
        .filter((option) => option.value !== "");

    return (
        <MultiSelectDropdown
            name={name}
            label={typeof label === "string" ? label : ""}
            options={filteredOptions}
            onChange={onChange}
            formState={value}
        />
    );
};

export default MultiSelectInput;
